// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"CheckboxGroup_checkboxGroup__Cammv","checkboxItem":"CheckboxGroup_checkboxItem__O+Nb7","checkboxInput":"CheckboxGroup_checkboxInput__IaRX+"};